import { Box, Collapse, Flex, Image } from "@chakra-ui/react";
import ShareDocIconImage from "./styles/images/shared-doc-folders.svg";
import { IoMdAddCircle } from "react-icons/io";
import { CreateSharedDoc } from "./CreateSharedDoc";


export const DisplaySharedDocEmptyState = ({
  dsrId,
  isMobileView,
  showAddDocumentForm,
  setShowAddDocumentForm,
  displaySignupPrompt,
  handleOpenSignupOrLoginModal,
  isLockedRoom,
  isRoomTemplate,
  handleShowPreviewPrompt,
  isArchivedDsr
}) => {
  return (
    <>
      <Flex
        display={showAddDocumentForm ? "none" : "flex"}
        mt="2em"
        justify="center"
        align="center"
        py="2.75em"
        border="1px solid #E5EAEF"
        rounded="0.5em"
        bg="white"
      >
        <Flex direction="column" justify="center" align="center">
          <Image
            src={ShareDocIconImage}
            alt="Empty Shared Doc Page"
            width="4em"
          />

          <Box
            fontSize="0.875em"
            fontWeight="400"
            lineHeight="1.5em"
            color="gray.500"
            py="1.5em"
            textAlign="center"
          >
            {isArchivedDsr ? `No shared documents` : `Share documents with your fellow Room members, all in one place`}
          </Box>

          {!isArchivedDsr &&
            <Box whiteSpace="nowrap">
              <Flex
                className="create-new-category-button"
                onClick={() =>
                  displaySignupPrompt
                    ? handleOpenSignupOrLoginModal()
                    : (isLockedRoom && isRoomTemplate) ? handleShowPreviewPrompt()
                      : setShowAddDocumentForm(!showAddDocumentForm)
                }
              >

                <Box className="create-new-category-button__button-text">
                  Add Document
                </Box>
                <Box
                  as={IoMdAddCircle}
                  boxSize="1.5em"
                  className="create-new-room-button__add-icon"
                />
              </Flex>
            </Box>
          }
        </Flex>
      </Flex>

      {showAddDocumentForm && (
        <Box opacity={"1.0"}>
          <Collapse in={true} animateOpacity style={{ width: "100%" }}>
            <CreateSharedDoc
              dsrId={dsrId}
              isMobileView={isMobileView}
              setShowAddDocumentForm={setShowAddDocumentForm}
              showAddDocummentForm={showAddDocumentForm}
            />
          </Collapse>
        </Box>
      )}
    </>
  );
};
